import axios from 'axios'
import { getCache } from '../lib/cache'

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

export async function getData(url, params) {
  let token = getCache('token')
  if (token) {
    axios.defaults.headers.common = { Authorization: `Bearer ${token}` }
  }
  let response = await axios.get(`${apiEndpoint}${url}`, { params: params })
  return response.data
}

export async function sendData(url, data) {
  let token = getCache('token')
  if (token) {
    axios.defaults.headers.common = { Authorization: `Bearer ${token}` }
  }
  let response = await axios.post(`${apiEndpoint}${url}`, data)
  return response.data
}

export async function sendFormData(url, data, file=null) {
  let token = getCache('token')
  if (token) {
    axios.defaults.headers.common = { Authorization: `Bearer ${token}` }
  }
  let formData = new FormData()
  for (let [key, value] of Object.entries(data)) {
    if (Array.isArray(value)) {
      value.forEach((val, index) => {
        formData.append(`${key}[${index}]`, val)
      })
    } else {
      formData.append(key, value)
    }
  }
  if (file) {
    formData.append(file.name,file.file)
  }
  let response = await axios.post(`${apiEndpoint}${url}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}
